import React from 'react';
import './LegalPages.css';

function Impressum() {
  return (
    <div>
      <section className="legal-hero">
        <h1>Impressum</h1>
      </section>
      <div className="legal-page">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Vorpoint<br />
          Ahmed Tahhan<br />
          Gorkistraße 84<br />
          04347 Leipzig
        </p>
        <h2>Kontakt</h2>
        <p>
          Telefon: +49-1778663796<br />
          E-Mail: info@vorpoint.de
        </p>
        <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>
          Ahmed Tahhan<br />
          Anschrift wie oben
        </p>
      </div>
    </div>
  );
}

export default Impressum;